import React, { Component } from "react";

export default class PatientEnrolmentSuccess extends Component {
  componentDidMount() {
    if (window.fbq) {
      fbq("track", "CompleteRegistration");
    }
  }

  render() {
    return (
      <div className="content-page">
        <section className="content-max-width">
          <div className="mdc-layout-grid">
            <h1>Success!</h1>
            <div className="mdc-layout-grid__inner">
              <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-6">
                <p>
                  <b>Your details have been recorded in KeepSight.</b>
                </p>
                <p>
                  When it’s time for your next diabetes eye check, KeepSight
                  will contact you to remind you to see your preferred eye care
                  provider.
                </p>
                <p>
                  It is recommended people with diabetes get eye checks at least
                  every two years. More frequent checks may be necessary if you
                  have pre-existing diabetes related eye disease like diabetic
                  retinopathy or if your eye care provider considers you to be
                  at a higher risk of eye disease. If so, you should follow the
                  advice of your eye care provider about the timing of your next
                  eye check.
                </p>

                <div className="section-image-text-right">
                  <p>
                    <a href="/eye_health_diabetes">Click here</a> if you would
                    like to learn more about your eye health and diabetes.
                  </p>
                  <p>
                    If you don’t want to be part of the KeepSight program, call
                    <a href={`tel:${window.SETTINGS.contact_phone_number}`}>
                      {window.SETTINGS.contact_phone_number}
                    </a>
                    .
                  </p>
                </div>
              </div>
              <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 text-center">
                <img alt="" src="/images/patient-enrolment-success.jpg" />
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
